import { render, staticRenderFns } from "./UiConfirmModal.vue?vue&type=template&id=e8c58f50&lang=pug&"
import script from "./UiConfirmModal.vue?vue&type=script&lang=js&"
export * from "./UiConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports